import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "filterNewlyArrived row" };
const _hoisted_2 = { class: "col-12 border-top pt-3 pb-2" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h3", { class: "font6-responsive strong mb-2 d-inline-block" }, "Neuheiten:", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_checkbox_input = _resolveComponent("checkbox-input");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_checkbox_input, {
                id: "NewlyArrived",
                name: "newlyArrived",
                text: "Aktuelle Neuzugänge",
                value: "newlyArrived",
                modelValue: _ctx.newlyArrived,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.newlyArrived) = $event))
            }, null, 8, ["modelValue"])
        ])
    ]));
}
